import React, { Suspense, lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { reservationsApi } from "../../store/reservationsApi";

const CalendarMaxOptimized = lazy(() =>
   import("../../components/APanel/CalendarMax/ACalendarOptimized"),
);

function getMaxPrefetchDate() {
   try {
      const saved = localStorage.getItem("__DV_MAX_MONTH");
      if (saved && /^\d{4}-\d{2}$/.test(saved)) {
         const [year, month] = saved.split("-").map(Number);
         return new Date(year, month - 1, 1);
      }
   } catch {}
   return new Date();
}

export default function APOrarMax() {
   const dispatch = useDispatch();

   useEffect(() => {
      document.title = "Instruire Auto | Lecții practice (MAX)";
      dispatch(
         reservationsApi.util.prefetch(
            "getReservationsForMonth",
            { date: getMaxPrefetchDate() },
            { force: false },
         ),
      );
   }, [dispatch]);

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense
            fallback={
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se încarcă Lecții practice (MAX)...</span>
               </div>
            }
         >
            <CalendarMaxOptimized />
         </Suspense>
      </main>
   );
}
